import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'qm-kendo-loading',
    template: `
        <div
            id="qmKendoLoading"
            *ngIf="loading"
            [class.loader-bg]="background"
            [class.loader-relative]="relative"
        >
            <kendo-loader
                type="converging-spinner"
                themeColor="primary"
                size="medium"
                [class.loader-bottom]="bottom"
                [style]="customStyles"
            ></kendo-loader>
        </div>
    `,
    styleUrls: ['./kendo-loading.component.scss']
})
export class KendoLoadingComponent {
    @Input() loading: boolean;
    @Input() bottom: boolean = false;
    @Input() customStyles: string = '';
    @Input() background: boolean = false;
    @Input() relative: boolean = false;
}
